<script setup>
import { onMounted, computed } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';

const store = useStore();
const { t } = useI18n();
const overview = useMapGetter('reseller/getOverview');

const formatMoney = value =>
  `R$ ${Number(value || 0)
    .toFixed(2)
    .replace('.', ',')}`;

const cards = computed(() => [
  {
    key: 'clients',
    label: t('REVENDA.OVERVIEW.CLIENTS'),
    value: overview.value?.clients_count ?? 0,
    icon: 'i-lucide-users',
  },
  {
    key: 'resellers',
    label: t('REVENDA.OVERVIEW.SUB_RESELLERS'),
    value: overview.value?.sub_resellers_count ?? 0,
    icon: 'i-lucide-store',
  },
  {
    key: 'revenue',
    label: t('REVENDA.OVERVIEW.MONTHLY_REVENUE'),
    value: formatMoney(overview.value?.monthly_revenue),
    icon: 'i-lucide-wallet',
  },
  {
    key: 'commissions',
    label: t('REVENDA.OVERVIEW.PENDING_COMMISSIONS'),
    value: formatMoney(overview.value?.pending_commissions),
    icon: 'i-lucide-coins',
  },
]);

onMounted(() => {
  store.dispatch('reseller/getOverview');
});
</script>

<template>
  <div class="grid grid-cols-2 gap-3 lg:grid-cols-4">
    <div
      v-for="card in cards"
      :key="card.key"
      class="flex flex-col gap-1 p-4 border rounded-xl border-n-weak bg-n-solid-2"
    >
      <div class="flex items-center gap-2 text-n-slate-11">
        <span :class="card.icon" class="text-base" />
        <span class="text-xs">{{ card.label }}</span>
      </div>
      <span class="text-xl font-semibold text-n-slate-12 tabular-nums">
        {{ card.value }}
      </span>
    </div>
  </div>
</template>
